import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import {
  DataCard,
  DataCardItem,
  TooltipItem,
  View,
} from './data-card.interface';

@Component({
  selector: 'app-data-card',
  templateUrl: './data-card.component.html',
  styleUrls: ['./data-card.component.scss'],
})
export class DataCardComponent implements OnChanges {
  @Input() dataCard: DataCard;
  @Output() onDownload: EventEmitter<void> = new EventEmitter<void>();
  @Output() onView: EventEmitter<View> = new EventEmitter<View>();

  getToolTip(item: { text?: string; items?: TooltipItem[] }) {
    if (!item) {
      return '';
    }
    if (item.text) {
      return item.text;
    }
    if (item.items && item.items.length > 0) {
      let tootltipText = '';
      item.items.forEach((i) => {
        tootltipText += `${i.label}: <b>${i.value}</b></br>`;
      });
      return tootltipText;
    }
    return '';
  }

  onDownloadClick() {
    this.onDownload.emit();
  }

  private _itemRows: DataCardItem[][] = [];
  private _lastDataCard: DataCard | null = null;

  ngOnChanges() {
    if (!this._lastDataCard || this._lastDataCard !== this.dataCard) {
      this._itemRows = this.calculateItemRows();
      this._lastDataCard = this.dataCard;
    }
  }

  private calculateItemRows(): DataCardItem[][] {
    if (!this.dataCard?.items) {
      return [];
    }

    const maxItemPerRow =
      this.dataCard.maxItemPerRow || this.dataCard.items.length;
    const rows: DataCardItem[][] = [];

    for (let i = 0; i < this.dataCard.items.length; i += maxItemPerRow) {
      rows.push(this.dataCard.items.slice(i, i + maxItemPerRow));
    }

    return rows;
  }

  getItemRows(): DataCardItem[][] {
    return this._itemRows;
  }

  getLastRowWidth(): string | null {
    const rows = this.getItemRows();
    if (rows.length <= 1) return null;
    let itemsInPreviousRow = rows[rows.length - 2]?.length || 1;
    if (!this.dataCard?.maxItemPerRow) {
      itemsInPreviousRow = 7;
    }
    return `calc((100% - ${
      (itemsInPreviousRow - 1) * 24
    }px) / ${itemsInPreviousRow})`;
  }

  onViewClick(veiw: View) {
    this.onView.emit(veiw);
  }
}
